module.exports = __webpack_public_path__ + "static/media/icon-ad-2.28c905e6.svg";